// extracted by mini-css-extract-plugin
export var container = "bottomRichText-module--container--u9sLK";
export var icon = "bottomRichText-module--icon--ntD9d";
export var show = "bottomRichText-module--show--3PZPY";
export var text = "bottomRichText-module--text--CRAYr";